var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:{ active: _vm.isMenuMobileVisible }},[_c('search-bar'),_c('notes'),_c('user-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }